import styles from "./index.module.scss";

export default function StatusLabel({ isRtcLive }: { isRtcLive: boolean }): JSX.Element {
  return (
    <div className={`${styles.status} ${!isRtcLive ? styles.status_close : ""}`} data-e="notes-status">
      {isRtcLive ? "Trwa" : "Zakończona"}
    </div>
  );
}
